<div class="distribution-receipt max-w-full lg:max-w-[368px] lg:bg-white">
    <div class="flex gap-x-12 lg:flex-col">
        @if (images(); as images) {
            <ui-m000-c010-image
                class="block h-[60px] w-[90px] lg:hidden"
                [image]="{
                    image: images[0],
                    desktop: { width: 90, height: 60 },
                    tablet: { width: 90, height: 60 },
                    mobile: { width: 90, height: 60 },
                }"
                [alt]="vehicleName() + '' + vehicleSubName()"
                [priority]="true"
                [highRes]="true"
                [cover]="true"
            />
        }
        <div class="p-0 lg:px-32 lg:py-24">
            <p class="leading-22 mb-8 break-words font-headline text-16 font-medium lg:mb-12 lg:text-20 lg:leading-25">
                {{ vehicleName() }}
                @if (vehicleSubName()) {
                    <br />
                    {{ vehicleSubName() }}
                }
            </p>
            <div class="flex justify-start gap-12 lg:justify-between">
                <div>
                    <p>
                        <span class="leading-22 font-headline text-16 font-medium">{{ price() }}</span>
                        <span class="leading-21 ml-4 text-14">EUR</span>
                    </p>
                    <p class="leading-21 text-14">Fahrzeugpreis</p>
                </div>
                <!-- @if (financingPrice(); as p) {
                    <div class="min-h-[70px] w-1 bg-grey-300"></div>
                    <div>
                        <p>
                            <span class="leading-22 font-headline text-16 font-medium">{{ p }}</span>
                            <span class="leading-21 ml-4 text-14">EUR</span>
                        </p>
                        <p class="leading-21 text-14">Finanzierung ab</p>
                        <button class="leading-21 text-14 text-accent underline" (click)="('')">
                            Finanzierungsdetails
                        </button>
                    </div>
                } -->
            </div>
        </div>
    </div>

    @if (images(); as images) {
        <div class="hidden h-[218px] w-full max-w-[368px] lg:block">
            <ngx-px-carousel-awesome-plus
                [centered]="false"
                [forceCenter]="false"
                [arrowPrevTemplate]="prevArrow"
                [arrowNextTemplate]="nextArrow"
                [showIndicator]="true"
                [showControls]="images.length > 1"
                sliderType="slider"
            >
                @for (image of images; track $index; let first = $first) {
                    <ui-m000-c010-image
                        class="block h-[206px] w-[368px]"
                        *ngxPxCarouselItem
                        [image]="{
                            image: image,
                            desktop: { width: 368, height: 206 },
                            tablet: { width: 368, height: 206 },
                            mobile: { width: 368, height: 206 },
                        }"
                        [alt]="vehicleName() + ' ' + vehicleSubName() + ' Slider Bild Nr. ' + ($index + 1)"
                        [priority]="first"
                        [highRes]="true"
                        [cover]="true"
                    />
                }
            </ngx-px-carousel-awesome-plus>
        </div>
    } @else {
        <div class="my-32 h-1 w-full bg-grey-300"></div>
    }

    @if (showAccesories() && accesories()?.length; as accesoriesData) {
        <button
            class="-mx-24 mt-16 flex w-[calc(100%+48px)] items-center justify-between gap-48 border-t-1 border-grey-300 px-24 py-10 lg:hidden"
            (click)="openAccesories.set(!openAccesories())"
        >
            <span class="leading-21 text-14">Gewähltes Zubehör</span>
            <i
                class="icon-chevron-down text-16 transition-all"
                [ngClass]="{
                    'rotate-180': openAccesories(),
                }"
            ></i>
        </button>

        <div
            class="pb-16 lg:px-32 lg:pb-32 lg:pt-24"
            [ngClass]="{
                'hidden lg:block': !openAccesories(),
            }"
        >
            <div class="bg-white px-12 py-8 lg:bg-transparent lg:p-0">
                <p class="leading-24 mb-12 hidden font-headline text-16 font-medium lg:block">Gewähltes Zubehör</p>
                @for (item of accesories(); track $index; let last = $last) {
                    <p
                        class="leading-16 text-14"
                        [ngClass]="{
                            'mb-16': !last,
                        }"
                    >
                        {{ item }}
                    </p>
                }
            </div>
            @if (accesorieLink(); as link) {
                <div class="flex justify-end pt-8 lg:justify-start lg:pt-24">
                    <a ui-m010-c020-icon-link [hyundaiRouterLink]="link" fragment="shop">Zubehör ändern</a>
                </div>
            }
            <p class="leading-21 text-14">{{ envkv() }}</p>
        </div>
    } @else {
        <p class="leading-21 min-h-32 pb-16 text-14 lg:px-32">
            {{ envkv() }}
        </p>
    }

    <ng-template #nextArrow>
        <i class="icon-slider-arrow hidden size-24 text-24 text-white md:block" (click)="$event.preventDefault()"></i>
    </ng-template>

    <ng-template #prevArrow>
        <i
            class="icon-slider-arrow hidden size-24 rotate-180 transform text-24 text-white md:block"
            (click)="$event.preventDefault()"
        ></i>
    </ng-template>
</div>
